import axios from 'axios';

import Notes from './components/dossierDetail/Notes.vue';
import Payment from './components/dossierDetail/Payment.vue';
import ClaimDetails from './components/dossierDetail/ClaimDetails.vue';
import Specification from './components/dossierDetail/Specification.vue';
import Actions from './components/dossierDetail/Actions.vue';
import Conversations from './components/dossierDetail/Conversations.vue';
import Invoices from './components/dossierDetail/Invoices.vue';
import Arrangements from './components/dossierDetail/Arrangements.vue';
import Deductions from './components/dossierDetail/Deductions.vue';
import Payments from './components/dossierDetail/Payments.vue';
import PaymentTransactions from './components/dossierDetail/PaymentTransactions.vue';
import RentalInformation from './components/dossierDetail/RentalInformation.vue';

import Tab from './components/tabs/tab.vue';
import Tabs from './components/tabs/tabs.vue';

export const dossierDetailAppLeft = {
	components: {
		Notes,
		Payment,
		Tab,
		Tabs,
	},
	data() {
		return {
			claimData: null,
			user: {},
			allowPayments: false
		}
	},
	async created() {
		if (sessionStorage.getItem("user") === null) {
			const response = await axios.get('/api/account');
			if (response.data.success) {
				sessionStorage.setItem("user", JSON.stringify(response.data.member));
			}
		}

		if (sessionStorage.getItem("user")) this.user = JSON.parse(sessionStorage.getItem("user"));

		this.allowPayments = this.user && this.user.organisationAllowPayments;

		try {
			const response = await axios.get(`/api/claims/${this.$store.getters.getLeftText('dossierid')}`);
			if (response ?? response.data) {
				this.claimData = response.data;
			} else {
				console.error('Invalid data received:', response);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	}
};

export const dossierDetailAppRight = {
	components: {
		ClaimDetails,
		Specification,
		Actions,
		Conversations,
		Invoices,
		Arrangements,
		Deductions,
		Payments,
		PaymentTransactions,
		RentalInformation,
		Tab,
		Tabs,
	},
};
